// extracted by mini-css-extract-plugin
module.exports = {"floatRightbarWrap":"App_floatRightbarWrap__2nChC","customerService":"App_customerService__1DD3E","survey":"App_survey__3I7s1"};